import { getCatalogVersion } from '@wix/ambassador-stores-catalog-v3-provision/http';
export const getStoreCatalogVersion = async (httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const catalogVersionResponse = await withErrorHandler(async () => httpClient.request(getCatalogVersion({})), {
    errorCodesMap: {}
  });
  return catalogVersionResponse.data.catalogVersion;
};
//# sourceMappingURL=get-stores-catalog-version.js.map